import { useEffect, useLayoutEffect, useRef, type TextareaHTMLAttributes } from "react";

/** A textarea that grows with its text (the prototype's `grow()`). */
export function GrowText(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const ref = useRef<HTMLTextAreaElement>(null);
  const fit = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight + 2}px`;
  };
  useLayoutEffect(fit, [props.value]);
  // Why: a narrower window wraps the text onto more lines; the box grows with it so nothing is cut off.
  useEffect(() => {
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []);
  return <textarea ref={ref} {...props} />;
}
